/* PureState video facade: one delegated click handler swaps a facade for its YouTube/Vimeo iframe (no third-party request before the click). */
if (!window.__psVideoFacade) {
  window.__psVideoFacade = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.ps-video-facade__play');
    if (!button) return;
    var facade = button.closest('.ps-video-facade');
    if (!facade) return;
    var type = facade.getAttribute('data-video-type');
    var id = encodeURIComponent(facade.getAttribute('data-video-id') || '');
    var direct = facade.getAttribute('data-video-src') || '';
    var src = '';
    if (direct) src = direct + (direct.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
    else if (type === 'youtube') src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    else if (type === 'vimeo') src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1';
    if (!src) return;
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = facade.getAttribute('data-video-title') || '';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    iframe.className = 'ps-video-facade__iframe';
    facade.classList.add('ps-video-facade--playing');
    facade.replaceChildren(iframe);
    iframe.focus();
  });
}
